var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","max-width":"100%","color":"#424949"}},[_c('v-spacer'),_c('h4',[_vm._v(_vm._s(new Date().getFullYear())+" — "),_c('strong',[_c('a',{attrs:{"href":"https://sigemed.com.ar"}},[_vm._v("SiGeMed")])]),_vm._v(" — info@sigemed.com.ar")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }